class YourLists extends Lists {
  constructor() {
    super();

    this.listsDetailPlaceholder = this.querySelector('[data-lists-detail-placeholder]');

    this.composeListDetail = this.composeListDetail.bind(this);
    this.composeListProductCards = this.composeListProductCards.bind(this);
    this.renderListsDetail = this.renderListsDetail.bind(this);
    this.openListsDetail = this.openListsDetail.bind(this);
    this.initListeners = this.initListeners.bind(this);
    this.closeListBoxes = this.closeListBoxes.bind(this);
    this.openListBoxes = this.openListBoxes.bind(this);
    this.ELM_cartNotification = document.querySelector('.pd-cart-notification');
    this.pdCartModal = document.querySelector('.pd-cart-notification .modal__toggle');

    this.updateLists();

    if (sessionStorage.getItem('openCart')) {
      // this.pdCartModal.click();
      const addProductsString = sessionStorage.getItem('addedProducts');
      this.ELM_cartNotification.open(event, addProductsString);
      sessionStorage.removeItem('openCart');
    }
  }

  async composeListProductCards(list) {
    let products = list.listcontents || [];
    let html = '';
    let promise = [];

    if (products.length) {
      // products = products.filter(p => !p.du.includes('dinosaur-blanket'));
      promise = await Promise.all([
        ...products.map((p) =>
          fetch(`${p.du}.js`, {
            headers: {
              "Content-Type": "application/json",
            },
          }).then(res => res.json())
          .catch(err => {})
        )
      ]);
    }

    if (products && products.length) {
      const dataErrorMessage = this.dataset.addAllErrorMessage || '';
      const dataListProductsNote = this.dataset.listProductsNote || '';
      const errorMessage = `<div class="error-message hidden">
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
          <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
          <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
          <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
        </svg>
        <div>${ dataErrorMessage }</div>
      </div>`;
      html += `<div
        data-list-products-wrapper
        data-list-id="${ list.lid }"
        data-list-name="${ list.lname }"
        data-list-item-count="${ list.cnt }"
        class="list-products-wrapper">
      `;
      html += `<div class="list-products-header">
        <span class="list-products-note">${dataListProductsNote}</span>
        <button data-add-all-products data-list-id="${ list.lid }" class="list-products-button pd-button pd-button--lively-blue pd-button--outline">Add all to cart</button>
        ${ errorMessage }
      </div>`;
      html += '<div data-list-products class="list-products">';
      products.forEach((product, idx) => {
        const available = promise[idx]?.available;
        html += `<div class="list-product-card">
          <div class="list-product-card-inner">
            <div class="list-product-card__image">
              <img src="${ product.iu }" alt="${ product.dt }" />
            </div>
            <p class="list-product-card__vendor">${ product.bt || '' }</p>
            <a class="list-product-card__title" href="${ product.du }">${ product.dt }</a>
            <p class="list-product-card__price">$${ product.pr.toFixed(2) }</p>`;
        if(available) {
          html += `<product-form data-product-handle="${product.handle}" class="product-form">
            <div class="product-form__error-message-wrapper" role="alert" hidden="">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
              </svg>
              <span class="product-form__error-message"></span>
            </div>
            <form
              method="post"
              action="/cart/add"
              id="product-form_${ list.lid }_${ product.id }"
              accept-charset="UTF-8"
              enctype="multipart/form-data"
              enctype="multipart/form-data"
              data-type="add-to-cart-form"
            >
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="id" value="${ product.epi }">
              <input type="hidden" class="select-on-focus" name="quantity" value="1">
              <button id="cart-button" class="pd-button button-add-to-cart pd-button--lively-blue pd-button--full-width" type="submit" name="add">Add To Cart</button>
              <div class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg><input type="hidden" name="discount" value=" ">
              </div>
            </form>
          </product-form>`;
        } else {
          html += '<button class="pd-button pd-button--lively-blue pd-button--disabled pd-button--full-width" style="margin-top: 15px;">Sold out</button>';
        }
        html += `
            <button
              data-remove-product-from-list
              data-lid="${ list.lid }"
              data-epi="${ product.epi }"
              data-empi="${ product.empi }"
              data-du="${ product.du }"
              class="list-product-card__button-remove"
            ></button>
          </div>
        </div>`
      });
      html += '</div>';
      html += `<div class="list-products-footer">
        <button
          data-add-all-products data-list-id="${ list.lid }" class="list-products-button list-products-button--bottom pd-button pd-button--lively-blue pd-button--outline">Add all to cart</button>
      </div>`;
      html += '</div>';
    }

    return html;
  }

  async composeListDetail(lists) {
    if (!lists || !lists.length) return '';
    let listDropdownHtml = '';
    let productCards = '';
    const promisesToAwait = [];

    lists?.forEach((list) => {
      listDropdownHtml += `<li aria-list-name="${ list.lname }">
        <a
          ${ list.cnt ? 'data-view-list' : 'disabled'}
          data-list-id="${ list.lid }"
        >${ list.lname } (<span data-count data-list-id="${ list.lid }">${ list.cnt }</span>)</a>
      </li>`;
      promisesToAwait.push(this.composeListProductCards(list));
    });

    const responses = await Promise.all(promisesToAwait);
    productCards = responses.join(' ');

    const html = `<div class="lists-detail">
      <div class="lists-detail-header">
        <div class="lists-detail-dropdown">
          <span data-dropdown-current-list class="lists-detail-dropdown__current">${ lists[0].lname } <span>(${ lists[0].cnt })</span></span>
          <ul data-lists-detail-dropdown class="hidden">
            ${ listDropdownHtml }
          </ul>
        </div>
      </div>
      ${ productCards }
    </div>`;

    return html;
  }

  composeListBoxContent(list) {
    const items = list.listcontents;
    let html = '';

    if (items && items.length) {
      const max = items.length > 3 ? 3 : items.length;
      html += `<div data-view-list data-list-id="${ list.lid }" class="list-box__items">`;

      for (let i = 0; i < max; i++) {
        const item = items[i];
        html += `<div class="list-box-item">
          <img src="${ item.iu }" alt="${ item.dt }" title="${ item.dt }" />
        </div>`
      }

      html += '</div>';
      html += `<a data-view-list data-list-id="${ list.lid }" class="pd-link list-box__button">View List</a>`;
    } else {
      const relevantUrl = this.predefinedLists[list.lname];
      html += '<p class="list-box__item-count">0 products</p>';
      html += '<div class="list-box__empty">This list is empty. Head to Lists to get started!</div>';
      if (relevantUrl) {
        html += `<a href="${ relevantUrl }" data-list-id="${ list.lid }" class="pd-link list-box__button">Browse ${ list.lname }</a>`;
      } else {
        html += `<a href="/" data-list-id="${ list.lid }" class="pd-link list-box__button">Shop now</a>`;
      }
    }

    return html;
  }

  async renderLists(lists) {
    let html = '';

    lists?.forEach(list => {
      const amount = list.cnt && list.cnt > 1 ? list.cnt + ' products' : list.cnt + ' product';
      html += `<div aria-list-name="${ list.lname }" class="list-box">
          <div class="list-box__inner">
            <h3 class="pd-heading-4 list-box__title">${ list.lname }</h3>
            ${list.cnt ? `<p class="list-box__item-count">${ amount }</p>`: ''}
            ${ this.composeListBoxContent.bind(this)(list) }
            <button class="delete-list-button" data-delete-list-button data-list-id="${ list.lid }">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12px" height="14px" viewBox="0 0 12 13" version="1.1">
                <g id="surface1">
                  <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 0 3.65625 L 0 2.769531 C 0.0195312 2.445312 0.152344 2.175781 0.402344 1.957031 C 0.652344 1.734375 0.945312 1.625 1.285156 1.625 L 2.570312 1.625 L 2.570312 1.21875 C 2.570312 0.882812 2.695312 0.59375 2.945312 0.355469 C 3.195312 0.121094 3.5 0 3.855469 0 L 8.140625 0 C 8.5 0 8.804688 0.121094 9.054688 0.355469 C 9.304688 0.59375 9.429688 0.882812 9.429688 1.21875 L 9.429688 1.625 L 10.714844 1.625 C 11.054688 1.625 11.347656 1.734375 11.597656 1.957031 C 11.847656 2.175781 11.980469 2.445312 12 2.769531 L 12 3.65625 C 12 3.875 11.914062 4.066406 11.746094 4.226562 C 11.574219 4.390625 11.375 4.46875 11.140625 4.46875 L 11.140625 11.375 C 11.140625 11.832031 10.976562 12.21875 10.648438 12.53125 C 10.316406 12.84375 9.910156 13 9.429688 13 L 2.570312 13 C 2.089844 13 1.683594 12.84375 1.351562 12.53125 C 1.023438 12.21875 0.855469 11.832031 0.855469 11.375 L 0.855469 4.46875 C 0.625 4.46875 0.425781 4.390625 0.253906 4.226562 C 0.0859375 4.066406 0 3.875 0 3.65625 Z M 0.855469 3.65625 L 11.140625 3.65625 L 11.140625 2.84375 C 11.140625 2.726562 11.101562 2.628906 11.023438 2.550781 C 10.941406 2.476562 10.839844 2.4375 10.714844 2.4375 L 1.285156 2.4375 C 1.160156 2.4375 1.058594 2.476562 0.976562 2.550781 C 0.898438 2.628906 0.855469 2.726562 0.855469 2.84375 Z M 1.714844 11.375 C 1.714844 11.59375 1.800781 11.785156 1.96875 11.945312 C 2.136719 12.105469 2.339844 12.1875 2.570312 12.1875 L 9.429688 12.1875 C 9.660156 12.1875 9.859375 12.105469 10.03125 11.945312 C 10.199219 11.785156 10.285156 11.59375 10.285156 11.375 L 10.285156 4.46875 L 1.714844 4.46875 Z M 2.570312 10.96875 L 2.570312 5.6875 C 2.570312 5.570312 2.613281 5.472656 2.691406 5.394531 C 2.773438 5.320312 2.875 5.28125 3 5.28125 L 3.855469 5.28125 C 3.980469 5.28125 4.085938 5.320312 4.164062 5.394531 C 4.246094 5.472656 4.285156 5.570312 4.285156 5.6875 L 4.285156 10.96875 C 4.285156 11.085938 4.246094 11.183594 4.164062 11.261719 C 4.085938 11.335938 3.980469 11.375 3.855469 11.375 L 3 11.375 C 2.875 11.375 2.773438 11.335938 2.691406 11.261719 C 2.613281 11.183594 2.570312 11.085938 2.570312 10.96875 Z M 3 10.96875 L 3.855469 10.96875 L 3.855469 5.6875 L 3 5.6875 Z M 3.429688 1.625 L 8.570312 1.625 L 8.570312 1.21875 C 8.570312 1.101562 8.53125 1.003906 8.449219 0.925781 C 8.371094 0.851562 8.265625 0.8125 8.140625 0.8125 L 3.855469 0.8125 C 3.730469 0.8125 3.628906 0.851562 3.550781 0.925781 C 3.46875 1.003906 3.429688 1.101562 3.429688 1.21875 Z M 5.140625 10.96875 L 5.140625 5.6875 C 5.140625 5.570312 5.183594 5.472656 5.261719 5.394531 C 5.34375 5.320312 5.445312 5.28125 5.570312 5.28125 L 6.429688 5.28125 C 6.554688 5.28125 6.65625 5.320312 6.734375 5.394531 C 6.816406 5.472656 6.855469 5.570312 6.855469 5.6875 L 6.855469 10.96875 C 6.855469 11.085938 6.816406 11.183594 6.734375 11.261719 C 6.65625 11.335938 6.554688 11.375 6.429688 11.375 L 5.570312 11.375 C 5.445312 11.375 5.34375 11.335938 5.261719 11.261719 C 5.183594 11.183594 5.140625 11.085938 5.140625 10.96875 Z M 5.570312 10.96875 L 6.429688 10.96875 L 6.429688 5.6875 L 5.570312 5.6875 Z M 7.714844 10.96875 L 7.714844 5.6875 C 7.714844 5.570312 7.753906 5.472656 7.835938 5.394531 C 7.914062 5.320312 8.015625 5.28125 8.140625 5.28125 L 9 5.28125 C 9.125 5.28125 9.226562 5.320312 9.308594 5.394531 C 9.386719 5.472656 9.429688 5.570312 9.429688 5.6875 L 9.429688 10.96875 C 9.429688 11.085938 9.386719 11.183594 9.308594 11.261719 C 9.226562 11.335938 9.125 11.375 9 11.375 L 8.140625 11.375 C 8.015625 11.375 7.914062 11.335938 7.835938 11.261719 C 7.753906 11.183594 7.714844 11.085938 7.714844 10.96875 Z M 8.140625 10.96875 L 9 10.96875 L 9 5.6875 L 8.140625 5.6875 Z M 8.140625 10.96875 "/>
                </g>
              </svg>
            </button>
          </div>
        </div>`
    });

    this.listsPlaceholder.innerHTML = html;
    await this.renderListsDetail(lists);
    this.disableLoading(this);
    this.initListeners();
    // this.checkList();
  }

  async renderListsDetail(lists) {
    const html = await this.composeListDetail(lists);
    this.listsDetailPlaceholder.innerHTML = html;
  }

  closeListBoxes() {
    this.listsPlaceholder.classList.add('hidden');
  }

  openListBoxes() {
    this.listsPlaceholder.classList.remove('hidden');
  }

  openListsDetail(lid) {
    this.listsDetailPlaceholder.classList.add('active');
    this.scrollIntoView(true);

    const targetListDetail = this.querySelector(`[data-list-products-wrapper][data-list-id="${ lid }"]`);
    const data = targetListDetail?.dataset;

    this.querySelectorAll('[data-list-products-wrapper]').forEach(listBlock => {
      listBlock.classList.remove('active');
    })
    targetListDetail.classList.add('active');
    this.querySelector('[data-dropdown-current-list]').innerHTML = `${ data.listName } <span>(<span data-list-id="${ lid }" data-count>${ data.listItemCount }</span>)<span>`;
    this.closeListBoxes();
  }

  initListeners() {
    this.querySelectorAll('[data-view-list]')?.forEach(button => {
      button.addEventListener('click', () => {
        this.openListsDetail(button.dataset.listId);
        this.querySelector('[data-lists-detail-dropdown]').classList.add('hidden');
      })
    });

    this.querySelector('[data-dropdown-current-list]')?.addEventListener('click', () => {
      this.querySelector('[data-lists-detail-dropdown]').classList.toggle('hidden');
    })

    this.querySelectorAll('[data-remove-product-from-list]')?.forEach(button => {
      button.addEventListener('click', () => {
        const self = this;
        const data = button.dataset;
        const listId = data.lid;
        const listItemMap = {
          epi: data.epi,
          empi: data.empi,
          du: data.du
        };

        function swymCallbackFn(swat) {
          swat.deleteFromList(listId, listItemMap, function(deletedListItem){
            // successfully deleted list item
            const listIndex = self.currentLists.findIndex(list => list.lid.toString() === listId.toString());
            const productIdx = self.currentLists[listIndex].listcontents.findIndex(item => item.epi.toString() === listItemMap.epi.toString());
            self.currentLists[listIndex].listcontents.splice(productIdx, 1);
            button.closest('.list-product-card').remove();
            const itemCountElms = self.querySelectorAll(`[data-count][data-list-id="${ listId }"]`);
            itemCountElms?.forEach(itemCountElm => {
              itemCountElm.innerHTML = Number(itemCountElm.innerText) - 1;
            })
          }, function(xhrObj) {
            // something went wrong
          });
        }
        if(!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymCallbackFn);
      })
    })

    this.querySelectorAll('[data-add-all-products]')?.forEach(button => {
      button.addEventListener('click', () => this.addAllProducts.bind(this)(button));
    })
  }

  addAllProducts(button) {
    const listId = button.dataset.listId;
    const currentList = this.currentLists.find(list => list.lid === listId);
    if (!currentList || !currentList.listcontents || !currentList.listcontents.length) return;

    const items = currentList.listcontents.map(item => ({
      id: item.epi,
      quantity: 1
    }));

    const itemIds =  currentList.listcontents.map(item => (item.epi));

    const body = JSON.stringify({ items });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then(response => {
        if (response.status === 200) {
          sessionStorage.setItem('openCart', 'yes');
          sessionStorage.setItem('addedProducts', itemIds.toString());
          return location.reload();
        }

        if (response.status === 422) {
          const header = button.closest('[data-list-products-wrapper]').querySelector('.list-products-header');
          header.querySelector('.error-message')?.classList.remove('hidden');
          header.scrollIntoView(true);
        }
      })
  }
}

customElements.define('your-lists', YourLists);